module.exports = new __parcel__URL__("trach_x1.8fa9fd6a.webp").toString();